import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { VhManagerListingComponent } from './vh-manager-listing/vh-manager-listing.component';

@Component({
  selector: 'app-vh-manager',
  templateUrl: './vh-manager.component.html',
  styleUrls: ['./vh-manager.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VhManagerComponent {

  @ViewChild('vehicleListing') vehicleListing!: VhManagerListingComponent;

  onVehicleUpdated(): void {
    // Refresh the vehicle listing when a vehicle is updated
    if (this.vehicleListing) {
      this.vehicleListing.loadVehicles();
    }
  }

  onMashoAdded(): void {
    // Handle masho added event if needed
    console.log('Masho added successfully');
  }

  onMashoUpdated(): void {
    // Handle masho updated event if needed
    console.log('Masho updated successfully');
  }

  onRemarkAdded(): void {
    // Refresh the vehicle listing when a remark is added
    if (this.vehicleListing) {
      this.vehicleListing.loadVehicles();
    }
  }

  onTransportPickupAdded(): void {
    // Handle transport pickup added event if needed
    console.log('Transport pickup added successfully');
  }

  onTransportPickupUpdated(): void {
    // Handle transport pickup updated event if needed
    console.log('Transport pickup updated successfully');
  }

  onPriceSheetSaved(): void {
    // Handle price sheet saved event if needed
    console.log('Price sheet saved successfully');
    // Optionally refresh the vehicle list or show a success message
  }

  onImagesUploaded(): void {
    // Refresh the vehicle listing when images are uploaded
    if (this.vehicleListing) {
      this.vehicleListing.loadVehicles();
    }
  }

  onCertificateGenerated(certificateData: any): void {
    // Handle certificate generation success
    console.log('Certificate generated successfully:', certificateData);

    // Refresh the vehicle listing to reflect any changes
    if (this.vehicleListing) {
      this.vehicleListing.loadVehicles();
    }

    // You can implement additional actions here such as:
    // - PDF generation
    // - Download functionality
    // - Email sending
    // - Print preview
  }

  onPurchaseManagerAdded(): void {
    // Handle purchase manager added event
    console.log('Purchase manager added successfully');

    // Refresh the vehicle listing to reflect any changes
    if (this.vehicleListing) {
      this.vehicleListing.loadVehicles();
    }
  }

  onPurchaseManagerUpdated(): void {
    // Handle purchase manager updated event
    console.log('Purchase manager updated successfully');

    // Refresh the vehicle listing to reflect any changes
    if (this.vehicleListing) {
      this.vehicleListing.loadVehicles();
    }
  }
}
